import { render, staticRenderFns } from "./ToggleSwitchSimple.vue?vue&type=template&id=9fe96448&scoped=true&"
import script from "./ToggleSwitchSimple.vue?vue&type=script&lang=js&"
export * from "./ToggleSwitchSimple.vue?vue&type=script&lang=js&"
import style0 from "./ToggleSwitchSimple.vue?vue&type=style&index=0&id=9fe96448&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe96448",
  null
  
)

export default component.exports